<div class="wrapper">
    	<app-admin-header [pageTitle]="tenantName" [pageSubTitle]="tenantSubName"></app-admin-header>
    <div class="batch-management-container">
        <div class="sub-header">
            <div class="left" *ngIf="batchData">
                <h6>All Batches</h6>
                <p>{{ batchCount }} batches found</p>
            </div>
            <div class="right">
                <button mat-flat-button color="primary" class="create-btn" (click)="onCreateBatch()">
                    <mat-icon>add</mat-icon> Create Batch
                </button>
            </div>
        </div>

		<ng-container *ngIf="isLoading; else pageContent">
			<div class="app-spinner">
				<mat-spinner diameter="60"></mat-spinner>
			</div>
		</ng-container>
		<ng-template #pageContent>
			<ng-container *ngIf="batchData.length > 0 ; else noBatchesFound">
        <div class="batch-grid">
            <mat-card class="batch-card" *ngFor="let batch of batchData">
                <div class="batch-header">
                    <div>
                        <h6>{{ batch.name }}</h6>
                        <p>{{ batch.department.name }}</p>
                    </div>
					<div class="d-flex">
					 <span><img src="assets/images/edit.svg" class="me-3" (click)="onEditBatchDialogBox(batch)"></span>
					<span><img src="assets/images/delete.svg" (click)="openDeleteBatchDialogBox(batch.id,batch.name)"></span>
					</div>
                </div>

                <div class="batch-body">
                    <div class="info">
                        <mat-icon>groups</mat-icon>
                        <span>{{ batch.student_count }} Students</span>
                    </div>

                    <div class="meta">
                        <div>
                            <p>Academic Year:</p>
                            <span class="pill">{{ batch.from_year }}-{{batch.to_year}}</span>
                        </div>
                        <div>
                            <p>Created On:</p>
                            <span>{{convertToIST(batch.created_at)}}</span> 
                        </div>
                    </div>
                </div>

                <div class="batch-footer">
                    <button pButton label="View Students ({{ batch.student_count }})" icon="pi pi-users"
                        class="p-button-outlined"  (click)="navigateToStudentsStats(batch.id)"></button>
                </div>
            </mat-card>
        </div>
		</ng-container>
		<ng-template #noBatchesFound>
			<p>no batches found</p>
		</ng-template>
		</ng-template>
    </div>
</div>